import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { FileDownloadService } from "../services/FileDownload-Service";
import { Router, NavigationExtras } from "@angular/router";
import { SohoModalDialogService, SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';

@Component({
  selector: 'app-quota-input-manual-gic',
  templateUrl: './quota-input-manual-gic.component.html',
  styleUrls: ['./quota-input-manual-gic.component.css']
})

export class QuotaInputManualGicComponent implements OnInit {
  @ViewChild(SohoDataGridComponent) datagrid!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  showBusy = true;
  Message = "Loading...";
  public data!: any[];
  public grid_Columns!:SohoDataGridColumn[];
  public GrdRequests: any;
  public filteredRequests: any;
  public filteredArray: any[] = [];
  public filteredIds: any[] = [];
  public filteredRequestTypaArray: any[] = [];
  public filteredRequestTypeIds: any[] = [];
  public filteredCreatedBy: any[] = [];
  emailAddress!: string;
  userData = new UserData();

  constructor(private capacityModelService: CapacityModelService, private fileDownloadService:FileDownloadService,
    private router: Router,
    private modalService: SohoModalDialogService,
    private authhelper: AuthHelper,
    private ngZone: NgZone) { }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData == null || this.userData == undefined ||  this.userData.Email == "" || this.userData.SecurityroleDescription == "") {
      this.authhelper.setUserRoleAndLoginDetails();
    }
    this.emailAddress = this.userData.Email;
    this.GetUploadedQuotaDetails();
  }
  GetUploadedQuotaDetails() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
      this.capacityModelService.GetManualGicQuotas(this.userData.Email).subscribe(
      detailedquotas => {
        this.data = detailedquotas;
        
        this.grid_Columns = this.gridColumns;
        if (this.data != null) {   
          this.GrdRequests = $("#QuotaApprovedatagrid").datagrid().data();
          this.GrdRequests.datagrid.renderRows();
          this.stop();
        }
      },
      (error: Response) => {
        this.stop();
        console.log(error);
      }
    );

  }
  DownloadFiles() {
    this.start();
    this.InitiatePlanDownload();
  }
    InitiatePlanDownload() {

    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    this.filteredRequestTypaArray=[];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    //console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
      this.filteredRequestTypaArray=[];
    }
    else {

      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.requestid;
          this.filteredRequestTypeIds = this.GrdRequests.datagrid.selectedRows()[i].data.requesttypeid;
          this.filteredArray.push(this.filteredIds);
          this.filteredRequestTypaArray.push(this.filteredRequestTypeIds);
        }

      }
    }
    if (this.filteredArray.length > 0) {
      this.start();
      for (var i = 0; i < this.filteredArray.length; i++) {
        filterid = <JSON><unknown>{ "requestid": this.filteredArray[i], "requesttypeid" : this.filteredRequestTypaArray[i], "userlogin": this.emailAddress == null ? "" : this.emailAddress };
        selectedid.push(filterid);
      }
      
      this.capacityModelService.GetPreSignedUrls(selectedid).subscribe(
        response => {
          this.fileDownloadService.DownloadFromPresignURL(response);
          this.ShowAlert("Alert", "Files Downloaded successfully.");

          if (this.data != null) {   
            this.GrdRequests = $("#QuotaApprovedatagrid").datagrid().data();
            this.GrdRequests.datagrid.renderRows();
          }
          this.stop();
        },
        (err: Response) => {
          console.log(err);
          this.stop();
          this.ShowAlert("Alert", err);
          this.ShowAlert("Alert", "Error while downloading.");
        }
      );
    }
    else {
      this.stop();
      this.ShowAlert("Information", "Please select atleast one to download.");
    }
  }
  DeleteManualQuotas(){
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    this.filteredCreatedBy = [];
    this.filteredRequestTypeIds = [];
    this.filteredRequestTypaArray = [];

    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    //console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {
      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          
          filterid = <JSON><unknown>{ "requestid": this.GrdRequests.datagrid.selectedRows()[i].data.requestid, "requesttypeid" : this.GrdRequests.datagrid.selectedRows()[i].data.requesttypeid,
           "status" : this.GrdRequests.datagrid.selectedRows()[i].data.status ,   "updatedby": this.emailAddress == null ? "" : this.emailAddress, "fiscalyear" : this.GrdRequests.datagrid.selectedRows()[i].data.fiscalyear };
          selectedid.push(filterid);
        }

      }
    }
    if (selectedid.length > 0) {
      this.start();
      this.capacityModelService.DeleteManualUpload(selectedid).subscribe(
        response => {
          this.ShowAlert("Confirmation", "Records deleted successfully.");
          this.stop();
          this.GetUploadedQuotaDetails();
        },
        (error: Response) => {
          console.log(error);
          this.stop();
          this.ShowAlert("Alert", "Error Occured.");
        }
      );
    }
    else {
      this.ShowAlert("Information", "Please select atleast one to delete");
    }
  }

  ArchiveFiles() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    this.filteredCreatedBy = [];
    this.filteredRequestTypeIds = [];
    this.filteredRequestTypaArray = [];

    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    //console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {
      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          
          filterid = <JSON><unknown>{ "requestid": this.GrdRequests.datagrid.selectedRows()[i].data.requestid, "requesttypeid" : this.GrdRequests.datagrid.selectedRows()[i].data.requesttypeid,
           "status" : this.GrdRequests.datagrid.selectedRows()[i].data.status ,   "updatedby": this.emailAddress == null ? "" : this.emailAddress, "fiscalyear" : this.GrdRequests.datagrid.selectedRows()[i].data.fiscalyear };
          selectedid.push(filterid);
        }

      }
    }
    if (selectedid.length > 0) {
      this.start();
      this.capacityModelService.ArchiveSelectedFiles(selectedid).subscribe(
        response => {
          this.ShowAlert("Confirmation", "Selected files Archived.");
          this.stop();
          this.GetUploadedQuotaDetails();
        },
        (error: Response) => {
          console.log(error);
          this.stop();
          this.ShowAlert("Alert", "Error Occured.");
        }
      );
    }
    else {
      this.ShowAlert("Information", "Please select atleast one to Archive");
    }
  }
  ShowAlert(Title: any, Message: any) {
    const dialogRef1 = this.modalService
      .message("<h2>" + Message + "</h2>")
      .buttons([
        {
          text: "Ok",
          click: () => {
            dialogRef1.close("Ok");

          },
          isDefault: true
        }
      ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }
  stop() {
    (this.busyIndicator as any).activated = false;
  }
  gridColumns = [
    {
      id: 'selectionCheckbox',
      sortable: false,
      resizable: false,
      formatter: Soho.Formatters.SelectionCheckbox,
      align: 'center'
    },
    //{
    //   id: "button-formatter",
    //   name: "Actions",
    //   text: "Delete Row",
    //   sortable: true,
    //   icon: "delete",
    //   align: "center",
    //   formatter: Soho.Formatters.Button,
    //   click: (args: any) => this.onClick(args)
    // },
    {
      id: "uniqueid",
      name: "Unique ID",
      field: "uniqueid",
      hidden: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "requestid",
      name: "Request ID",
      sortable: true,
      field: "requestid",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    // {
    //   id: "filename",
    //   name: "File name",
    //   sortable: true,
    //   field: "filename",
    //   filterType: 'text',
    //   formatter: Soho.Formatters.Text
    // },
    {
      id: "requesttype",
      name: "Request Type",
      field: "requesttype",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
      width : 250
      //dateFormat: 'M/d/yyyy hh:mm:ss'
    },
    {
      id: "status",
      name: "Status",
      field: "status",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
      //dateFormat: 'M/d/yyyy hh:mm:ss'
    },
    {
      id: "created",
      name: "Submitted On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss',
      width : 180

    },
    {
      id: "createdby",
      name: "Submitted By",
      field: "createdby",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text,
      width : 250
    },
    {
      id: 'download',
      name: 'Download',
      field: 'downloadfile',
      icon: 'download',
      formatter: Soho.Formatters.Button,
      click: (e, args) => this.downloadFile(args),
    }

  ];
  downloadFile(args) {
    this.start();
    let selecteddonwloadid: any[] = [];
    let downlaodid!: any;
    // args["0"].item.uniqueid
    downlaodid = <JSON><unknown>{ "requestid": args["0"].item.requestid, "requesttypeid" : args["0"].item.requesttypeid, "userlogin": this.emailAddress == null ? "" : this.emailAddress };
    selecteddonwloadid.push(downlaodid);
    if(selecteddonwloadid.length >0){
      this.capacityModelService.GetPreSignedUrls(selecteddonwloadid).subscribe(
        response => {
          this.fileDownloadService.SingleDownloadFromPresignURL(response["0"].PresignedURL);
          this.stop()
        },
        (err: Response) => {
          console.log(err);
          this.stop();
        }
      );
    }
    
    
  }
}
